import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

export default createGlobalStyle`
  ${reset}   

  body {
    width: 100%;
    height: 100vh;
    font-family: 'Montserrat', sans-serif;
    background: ${props => props.theme.colors.background};
  }
  
  #root {
    display: flex;
    align-items: start;
    justify-content: space-between;
    font-size: 16px;

    @media(min-height: 720px) {
    font-size: 18px;
    }

    main {
      width: 100%;
      /* height: 100%; */
      /* padding: 0 0 1rem; */
      /* padding: .8rem 3rem .8rem 0; */
      /* margin-left: 1rem; */
      align-self: baseline;
    }
  }
  a{
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: 'Montserrat',sans-serif;
    cursor: pointer;
  }

  .react-modal {
    z-index: 1000;
  }

  .react-modal .modal-custom {
    :focus-visible {
      outline: none;
    }
  }
`;

